<template>
  <div class="mob-breadcrumb">
    <nav aria-label="Breadcrumb">
      <ol class="flex">
        <li key="back" v-if="back">
          <router-link :to="back">
            <Icon icon="ep:back" />
          </router-link>
        </li>
        <li v-for="(item, index) in items" :key="index">
          <template v-if="item.to">
            <router-link :to="item.to">{{ item.label }}</router-link>
          </template>
          <template v-else>
            <span>{{ item.label }}</span>
          </template>
        </li>
      </ol>
    </nav>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";

export default {
  name: "MobBreadcrumb",
  components: {
    Icon,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    back: String,
  },
};
</script>

<style scoped>
li {
  @apply flex items-center text-white;
}

li::before {
  @apply px-2;
  content: "/";
}

li:first-child::before {
  content: "";
  padding: 0;
}

li.current {
  @apply font-medium;
}

</style>
